<template>
	<div class="media-wrap" v-on:click="$parent.fetchData()">
		<div
			class="key-img"
			v-if="mediadata.img"
			:class="mediadata.img.orient + ' type-' + mediadata.type"
		>
			<span class="img-placeholder" v-bind:style="'padding-bottom:' + (mediadata.img.height/mediadata.img.width)*100 + '%'"></span>
			<img
				v-if="allowMediaLoad"
				:src="rootPath + mediadata.img.src"
				v-bind:width="mediadata.img.width"
				v-bind:height="mediadata.img.height"
				border="0"
				oncontextmenu="return false"
				draggable="false"
			/>
		</div>
	</div>
</template>

<script>
// var inView = require('in-view');
export default {
	created() {
		// flag switch point
		// this.rootPath =
		// 	process.env.NODE_ENV === "production"
		// 		? "http://54.87.134.1/wp-content/uploads"
		// 		: "http://54.87.134.1/wp-content/uploads";
		this.rootPath =
			process.env.NODE_ENV === "production"
				? "/interactives/moma_through_time/static/uploads"
				: "/static/uploads";
		if (
			this.mediadata !== null &&
			typeof this.mediadata.type !== "undefined"
		) {
			if (
				typeof this.mediadata !== "undefined" &&
				this.mediadata !== null &&
				this.mediadata.type === "img"
			) {
				this.hasImg = true;
			}
		}
	},
	mounted() {
		
	},
	data() {
		return {
			hasImg: false,
			rootPath: "/"
		};
	},
	props: ["mediadata","allowMediaLoad"],
	methods: {
		
	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
.media-wrap {
	width:100%;
	max-width:780px;
	margin-left:auto;
	margin-right:auto;
}
.key-img *, .key-yt * {
	opacity:0;
	animation:mediaIn 1s 0.2s forwards 1;
}
.key-img.type-youtube,
.key-img.type-vid {
	&:BEFORE, &:AFTER {
		content:"";
		z-index:2;
		position:absolute;
		top:50%;
		left:50%;
		transform:translateX(-50%) translateY(-50%);
	}
	&:BEFORE {
		width:80px;
		height:80px;
		background:rgba(255,255,255,0.9);
		border-radius:50%;
		.up-2 &, .up-3 &, .up-4 & {
			width:36px;
			height:36px;
		}
	}
	&:AFTER {
		box-sizing: border-box;
		height: 30px;
		border-color: transparent transparent transparent #202020;
		border-style: solid;
		border-width: 15px 0 15px 26px;
		margin-left:4px;

		.up-2 &, .up-3 &, .up-4 & {
			box-sizing: border-box;
			height: 14px;
			border-color: transparent transparent transparent #202020;
			border-style: solid;
			border-width: 7px 0 7px 12px;
			margin-left:2px;
		}
	}
}

@keyframes mediaIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
.img-placeholder {
	display:none;
	@include aboveTablet {
		.up-1 .hor &, .up-1 .single:not(.single-el) & {
			display:block;
			width:100%;
			height:0;

		}
		.up-1 .single-el .vert &,
		.up-1 .single-el .vertX & {
			display:block;
			width:auto;
			height:90vh;
			max-height:640px;
			padding:0 !important;
		}
	}
}
.key-img {
	position:relative;
	backface-visiblity: hidden;
	display: flex;
	margin:0 auto 12px;
	// &.hor {
	// 	align-items:flex-end;
	// }

	.up-1 .single-el & {
		display:block;
		margin-bottom:1.4em;
		img {
			object-fit:initial;
		}
		@include aboveTablet {
			&.hor {
				img {
					position:absolute;
					top:50%;
					left:50%;
					transform:translateX(-50%) translateY(-50%);

				}
			}
			&.vert, 
			&.vertX {
				img {
					position:absolute;
					top:0;
					height:100%;
					width:auto;
					left:50%;
					transform:translateX(-50%);

				}
			}
		}
	}
	
	.up-1 .single:not(.single-el) & {
		height:150px;
	}
	.up-2 &,
	.up-3 &,
	.up-4 & {
		height: 150px;
	}
	img {
		object-fit: contain;
		width: 100%;
		height: auto;
		margin-left: auto;
		margin-right: auto;
		.up-4 & {
			// align-self:flex-end;
		}
	}
	&.vert { max-width:75%; }
	&.vertX { max-width:55%; }
	&.squareminus { max-width:90%; }
}
.key-yt {
	position: relative;
	padding-bottom: 56.25%;
	cursor: pointer;
	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}
}
.size-img {
	img {
		position: absolute;
		top: 0;
		left: 0;
		width: auto;
		height: 100%;
		display: block;
		margin-left: auto;
		margin-right: auto;
		cursor: pointer;
	}
}
</style>
